import React from 'react';
import IconCross from '../../../assets/icons/cross-icon.svg';
import './FilterLabel.scss';

interface IFilterLabelProps {
  label: string;
  onRemove: () => void;
}
const FilterLabel = ({ label, onRemove }: IFilterLabelProps) => (
  <button type='button' className={'filterLabelContainer'} onClick={onRemove}>
    <span>{label}</span>
    <IconCross />
  </button>
);

export { FilterLabel };
